import React from "react";
import { Button } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { formatCurrency, formatCrypto, formatExchangeRate } from "../utils/operationsUtils";

// AIDEV-NOTE: Sub-operations list component with proper display formatting (no NumericFormat for display)
const SubOperationsList = ({
  subOperacoes,
  setSubOperacoes,
  moeda,
  direcao,
  cliente,
  setViewMode,
}) => {
  const removeSubOperation = (index) => {
    setSubOperacoes((prev) => prev.filter((_, i) => i !== index));
  };

  // AIDEV-NOTE: Validation to enable/disable sub-operation buttons
  const canAddSubOperations = cliente && direcao && moeda?.data?.moeda;

  if (subOperacoes.length === 0) {
    return (
      <div className="text-center py-4">
        <FeatherIcon icon="layers" size={48} className="text-muted mb-3" />
        <p className="text-muted">Nenhuma sub-operação adicionada</p>
        <div className="d-flex gap-2 justify-content-center">
          <Button
            color="outline-primary"
            size="sm"
            onClick={() => setViewMode("add")}
            disabled={!canAddSubOperations}
            title={
              !canAddSubOperations
                ? "Selecione Cliente, Direção e Moeda primeiro"
                : ""
            }
          >
            <FeatherIcon icon="search" className="me-1" size={14} />
            Buscar Existentes
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => setViewMode("build")}
            disabled={!canAddSubOperations}
            title={
              !canAddSubOperations
                ? "Selecione Cliente, Direção e Moeda primeiro"
                : ""
            }
          >
            <FeatherIcon icon="plus" className="me-1" size={14} />
            Nova
          </Button>
        </div>

        {!canAddSubOperations && (
          <small className="text-muted d-block text-center mt-2">
            <i className="ri-information-line me-1"></i>
            Selecione Cliente, Direção e Moeda para adicionar sub-operações
          </small>
        )}
      </div>
    );
  }

  return (
    <div>
      {subOperacoes.map((sub, index) => (
        <div key={index} className="border rounded p-2 mb-2">
          <div className="d-flex justify-content-between align-items-start">
            <div className="flex-grow-1">
              {/* Header com fornecedor e tipo */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <h6 className="mb-0 text-primary fs-6">
                  {sub.fornecedor_nome}
                </h6>
                {sub.sub_op_id > 0 && (
                  <small className="badge bg-info">ID: {sub.sub_op_id}</small>
                )}
              </div>

              {/* Informações em grid compacto */}
              <div className="row g-1 small text-muted">
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="ri-arrow-up-down-line me-1"></i>
                    <span
                      className={
                        sub.direcao === "compra"
                          ? "text-success"
                          : "text-danger"
                      }
                    >
                      {sub.direcao}
                    </span>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <i className="ri-money-dollar-circle-line me-1"></i>
                    <span className="fw-medium">{sub.moeda}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="d-flex justify-content-between">
                    <span>
                      <i className="ri-scales-line me-1"></i>
                      {sub.moeda === "BRL"
                        ? formatCurrency(sub.quantidade)
                        : formatCrypto(sub.quantidade, sub.moeda)}
                    </span>
                    <span className="fw-medium">
                      <i className="ri-bank-card-line me-1"></i>
                      {formatCurrency(sub.total_brl)}
                    </span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <i className="ri-exchange-line me-1"></i>
                    <span className="fw-medium text-info">
                      Cotação: {formatExchangeRate(sub.total_brl, sub.quantidade, sub.moeda)}
                      {sub.moeda !== "BRL" && ` / ${sub.moeda}`}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Button
              color="outline-danger"
              size="sm"
              onClick={() => removeSubOperation(index)}
              className="ms-2 flex-shrink-0"
              title="Remover sub-operação"
            >
              <FeatherIcon icon="trash-2" size={12} />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SubOperationsList;
